interface StorageShape {
    getItem: (key: string) => string | null;
    setItem: (key: string, value: any) => void;
    removeItem: (key: string) => void;
}

import {Hit} from './index';

type Handler = (entry: Hit | any) => void;

export default class OfflineQueue {
    public static hasOnlineSupport = typeof navigator.onLine === 'boolean';

    private storage: StorageShape;
    private key: string;

    public constructor(storage?: StorageShape, key?: string) {
        this.storage = storage || window.sessionStorage;
        this.key = key || 'tp-offline-queue';
    }

    public getStored(): string | null {
        return this.storage.getItem(this.key);
    }

    public append(data: Hit): boolean {
        try {
            if (!this.storage) {
                return false;
            }
            let state: Hit[] = [];
            let stored = this.getStored();
            if (stored) {
                stored = JSON.parse(stored);
                if (Array.isArray(stored)) {
                    state = stored;
                }
            }
            state.push(data);
            this.storage.setItem(this.key, JSON.stringify(state));
            return true;
        } catch (e) {
            if (window.console) {
                // eslint-disable-next-line no-console
                console.error(e);
            }
        }
        return false;
    }

    public processQueueAndEmpty(handle: Handler): boolean {
        try {
            if (!this.storage) {
                return false;
            }
            const state = this.getStored();
            if (state) {
                const entries: Hit[] = JSON.parse(state);
                if (Array.isArray(entries)) {
                    entries.forEach((entry: Hit) => handle(entry));
                }
                this.storage.removeItem(this.key);
            }
            return true;
        } catch (e) {
            if (window.console) {
                // eslint-disable-next-line no-console
                console.error(e);
            }
        }
        return false;
    }
}
